function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M481.067,0.533H21.333C9.6,0.533,0,10.133,0,21.867v458.667c0,11.733,9.6,21.333,21.333,21.333H480 c11.733,0,21.333-9.6,22.4-20.267V21.867C502.4,10.133,492.8,0.533,481.067,0.533z M206.933,460.267H57.6l121.6-155.733 l71.467,107.733c0,0,0,1.067,1.067,1.067L206.933,460.267C208,459.2,208,460.267,206.933,460.267z M459.733,460.267h-195.2 l195.2-206.933V460.267z M459.733,42.133v149.333l-179.2,189.867l-83.2-125.867c-4.267-6.4-10.667-9.6-17.067-9.6 c-6.4,0-12.8,3.2-17.067,8.533L41.6,412.266v-371.2h418.133V42.133z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M289.067,91.2c-41.6,0-76.8,33.067-76.8,75.733c0,42.667,35.2,76.8,76.8,76.8c42.667,0,76.8-33.067,76.8-75.733 C365.867,125.333,330.667,91.2,289.067,91.2z M289.067,201.067c-18.133,0-34.133-14.933-34.133-34.133 c0-18.133,14.933-34.133,34.133-34.133c19.2,0,34.133,16,34.133,34.133C323.2,185.067,308.267,201.067,289.067,201.067z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var SvgPictureImage = function SvgPictureImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502.4 502.4",
    style: {
      enableBackground: "new 0 0 502.4 502.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPictureImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picture-image.a95b3758.svg";
export { ForwardRef as ReactComponent };